<transition name="updated" mode="out-in"><div class="updated-wrapper" :key="transitionKey"><slot></slot></div></transition>